<template lang="pug">
	div#gdpr-banner(v-if="showGdprBanner")
		b-container.main
			b-row
				b-col(lg="8" md="12" sm="12" cols="12")
					h3 This site uses cookies
					p 
						| We use cookies to personalize ads, analyze our traffic and provide you with more relevant content. For more information, please reference our 
						a(href="/privacy_policy/") privacy policy.
				b-col(lg="4" md="12" sm="12" cols="12")
					div#gdpr-button
						a#gdpr-ok(@click="closeGdprBanner()")
							|	Ok, I agree
</template>

<style lang="stylus">
	#gdpr-banner
		width: 100%
		height: 130px
		background: #3D75B2
		position: fixed
		bottom: 0
		z-index: 9999
		color: #FFF
		box-sizing: border-box
		h3
			font-size: body-font-size-md
			margin-top: 20px
		p
			color: #FFF
			a
				color: #FFF
				text-decoration: underline
		#gdpr-button
			height: 130px
			vertical-align: middle
			display: table-cell
			width: 33%
			#gdpr-ok
				padding: 10px 20px;
				text-decoration: none
				text-transform: uppercase
				color: #FFF
				border: 1px solid #FFF
				border-radius: 3px
				box-sizing: border-box
				transition: background-color .15s ease-in-out
				float: right
				cursor: pointer
				font-size: body-font-size
				&:hover
					background: #5189c1
	
	@media (max-width: 990px)	
		#gdpr-banner
			height: auto !important
		#gdpr-button
			width: 100% !important
			height: 45px !important
			display: block !important
			text-align: center
			margin: 10px auto !important
			#gdpr-ok
				float: none !important
</style>

<script>
export default {
	components: {},

	async mounted(){
		this.showGdprBanner = false
		if(!this.$cookies.get("gdpr_accepted") && !this.$cookies.get("skip_gdpr")){
			const query = `
				query{
					ip_data(ip_address: "${this.$store.state.currentIp}")
				}
			`
			try {
				const response = await this.$httpService.graphql(query)
				if(response.data && response.data.ip_data != ""){
					let json = JSON.parse(response.data.ip_data)
					if (json.location && json.location.is_eu){
						this.showGdprBanner = true
					}
				}
			} catch (e) {
			}

			if(!this.showGdprBanner){
				// Create skip_gdpr cookie
				let date = new Date()
				date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000)) // Expires in 1 month
				let	expires = "; expires=" + date.toGMTString()
				document.cookie = encodeURIComponent("skip_gdpr") + "=" + encodeURIComponent("1") + expires + "; domain=savingforcollege.com; path=/ ;"
			}
		}
	},
	data(){
		return {
			showGdprBanner: false
		}
	},
	methods: {
		closeGdprBanner(){
			// Create gdpr cookie
			let date = new Date()
			date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000)) // Expires in 1 month
			let expires = "; expires=" + date.toGMTString()
			document.cookie = encodeURIComponent("gdpr_accepted") + "=" + encodeURIComponent("1") + expires + "; domain=savingforcollege.com; path=/ ;"
			this.showGdprBanner = false
		}
	}
}
</script>
